import { Controller } from "@hotwired/stimulus"
import Toastify from "toastify-js/src/toastify"

export default class extends Controller {
  static targets = [];

  connect() {
    let flash_key = this.data.get("key");
    let flash_value = this.data.get("value");

    const options = {
      text: flash_value,
      duration: 3000,
      gravity: "top",
      position: "right",
      stopOnFocus: true,
      className: `toast-${flash_key}`,
      style: {
        background: this.getBackgroundColor(flash_key),
      }
    }

    Toastify(options).showToast();
  }

  getBackgroundColor(type) {
    switch (type) {
      case "notice":
      case "success":
        return "var(--bs-success)";
      case "info":
        return "var(--bs-info)";
      case "warning":
        return "var(--bs-warning)";
      case "alert":
      case "error":
        return "var(--bs-danger)";
      default:
        return "var(--bs-primary)";
    }
  }
}
